module.exports = __webpack_public_path__ + "static/media/edit.69251db5.svg";